import axios from "axios";

const state = {
  organisationId: null,
  cancellationReasons: {},
  websitesWithPublishedChanges: [],
  currentStep: 1,
  maxSteps: 2,
  validationErrors: {}
};

const getters = {
  organisationId: ({organisationId}) => organisationId,
  websitesWithPublishedChanges: ({websitesWithPublishedChanges}) => websitesWithPublishedChanges,
  cancellationReasons: ({cancellationReasons}) => cancellationReasons,
  currentStep: ({currentStep}) => currentStep,
  validationErrors: ({validationErrors}) => validationErrors,
};

const mutations = {
  setOrganisationId: (state, id) => state.organisationId = id,
  setWebsitesWithPublishedChanges: (state, websites) => state.websitesWithPublishedChanges = websites,
  setValidationErrors: (state, errors) => state.validationErrors = errors,
  setCancellationReasons: (state, reasons) => state.cancellationReasons = reasons,
  setCurrentStep: (state, step) => {
    if (step <= state.maxSteps){
      state.currentStep = step;
    }
  },
};

const actions = {
  setOrganisationId: ({commit}, id) => commit('setOrganisationId', id),
  setWebsitesWithPublishedChanges: ({commit}, websites) => commit('setWebsitesWithPublishedChanges', websites),
  setCancellationReasons: ({commit}, reasons) => commit('setCancellationReasons', reasons),
  submitCancellationForm: ({commit, getters},{cancellationReason, whatToImprove}) => {
    return new Promise((resolve, reject) => {
      axios.post(`/settings/agency/${getters.organisationId}/cancel`, {
        cancellation_reason: cancellationReason,
        what_to_improve: whatToImprove,
      })
        .then(() => resolve())
        .catch((error) => {
          console.log(error);
          const {response} = error;
          if (response.status === 422) {
            commit('setValidationErrors', response.data.errors);
          }
          reject();
        });
    });
  },
  nextStep: ({commit}) => commit('setCurrentStep', state.currentStep + 1),
  previousStep: ({commit, getters}) => {
    if (getters.currentStep === 1 || getters.websitesWithPublishedChanges.length === 0) {
      window.location = '/settings#account';
      return;
    }
    commit('setCurrentStep', getters.currentStep - 1);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
